import React from 'react'
import { Box, CircularProgress } from '@mui/material'

const PageLoading = ({ loading }) => loading ? <Box textAlign="center"><CircularProgress/></Box> : <></>

export default PageLoading
